export type AttributeSearchSpaceTracePair = {
  projectIdentifier: string;
  projectId: string;
  shortId: string;
};

export const ATTRIBUTE_SEARCH_SPACE_TRACE_LIMIT = 200;
export const ATTRIBUTE_SEARCH_SPACE_TRACE_DB_LIMIT = 1000;

function serializePair({ projectIdentifier, shortId }: AttributeSearchSpaceTracePair): string {
  return `${projectIdentifier}/${shortId}`;
}

export function mergeAttributeSearchSpaceTrace(
  existing: AttributeSearchSpaceTracePair[],
  incoming: AttributeSearchSpaceTracePair[],
  limit = ATTRIBUTE_SEARCH_SPACE_TRACE_LIMIT,
): AttributeSearchSpaceTracePair[] {
  if (incoming.length === 0) {
    return existing;
  }

  const existingByKey = new Map<string, AttributeSearchSpaceTracePair>();

  for (const pair of existing) {
    existingByKey.set(serializePair(pair), pair);
  }

  for (const pair of incoming) {
    const key = serializePair(pair);

    existingByKey.delete(key);
    existingByKey.set(key, pair);
  }

  const merged = Array.from(existingByKey.values());

  if (merged.length <= limit) {
    return merged;
  }

  return merged.slice(merged.length - limit);
}
